import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import MarkdownRenderer from "../../MarkdownRenderer";
import { convertMdxToMd } from "../../../lib/convertMdx";
import geoVerifyOverviewFile from "../../../assets/markDownFiles/verify/overview.md";

const GeoVerifyOverview = () => {
  const [content, setContent] = useState("");
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (
      typeof geoVerifyOverviewFile === "string" &&
      geoVerifyOverviewFile.startsWith("/static")
    ) {
      fetch(geoVerifyOverviewFile)
        .then((res) => res.text())
        .then((raw) => setContent(convertMdxToMd(raw)));
    } else {
      setContent(convertMdxToMd(geoVerifyOverviewFile));
    }
  }, []);

  return (
    <Box sx={{ padding: "0" }}>
      <Typography
        sx={{
          color: "#e54f9c",
          fontWeight: "900",
          fontSize: "0.8rem",
          marginBottom: "0.35rem",
          marginLeft: isDesktop ? "0" : "5%",
        }}
      >
        ACT Verify
      </Typography>
      {content ? <MarkdownRenderer content={content} /> : <p>Loading...</p>}
    </Box>
  );
};

export default GeoVerifyOverview;
